import {useEffect} from 'react';
import {Navigate, Outlet} from 'react-router';
import {useSigninStatus} from '../auth/hooks/useSigninStatus';
import {startupProfiler} from '../common/utils/startupProfiler';
import {useAppLoading} from '../main/hooks/useAppLoading';
import {usePostLoginState} from '../navigation/hooks/usePostLoginState';
import {ComponentWithoutChildren} from '../react/types';
import {Paths} from './paths';

export const PrivateOutlet: ComponentWithoutChildren = () => {
  /*
   * Note: WithCurrentUser is a parent of PrivateOutlet in PrivateAppOutlet,
   * so we are guaranteed that useSigninStatus().isloading
   * will be false and useSigninStatus().signinError
   * will be undefined by the time PrivateOutlet is rendered.
   */

  const {isSignedIn} = useSigninStatus();
  const {persistPostLoginState, postLoginState} = usePostLoginState();
  const {isAppLoading, setAppLoading} = useAppLoading();

  useEffect(() => {
    if (isSignedIn) {
      if (isAppLoading) {
        startupProfiler.mark('Private Route Outlet Mounted');
        setAppLoading(false);
      }
    } else {
      // Redirect back to this path after logging in
      persistPostLoginState();
    }
  }, [isAppLoading, isSignedIn, postLoginState, persistPostLoginState, setAppLoading]);

  if (!isSignedIn) {
    return <Navigate replace state={postLoginState} to={Paths.Login} />;
  }

  return <Outlet />;
};
